/* ---------------------------------------------
   STROUD -- Main JavaScript
   Shopify Theme Asset
--------------------------------------------- */

// -- SCROLL REVEAL ------------------------------
const revealObserver = new IntersectionObserver(entries => {
  entries.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('in'); revealObserver.unobserve(e.target); }
  });
}, { threshold: 0.05, rootMargin: '0px 0px -30px 0px' });
document.querySelectorAll('.rv').forEach(el => revealObserver.observe(el));

// -- NAV ----------------------------------------
const nav = document.getElementById('nav');
const ham = document.getElementById('ham');
const drawer = document.getElementById('mob-drawer');

if (nav && !nav.classList.contains('always-solid')) {
  const heroEl = document.getElementById('hero');
  const heroLogo = document.getElementById('heroLogo');

  function heroScroll() {
    const h = heroEl ? heroEl.offsetHeight : 0;
    const y = window.scrollY;
    nav.classList.toggle('solid', y > h * 0.65);
    if (heroLogo) {
      heroLogo.classList.toggle('hero-logo-faded', y > h * 0.15);
    }
  }
  window.addEventListener('scroll', heroScroll, { passive: true });
  heroScroll();
} else if (nav) {
  window.addEventListener('scroll', () => {
    nav.classList.toggle('solid', window.scrollY > 10);
  }, { passive: true });
}

if (ham && drawer) {
  const nav = document.getElementById('nav');
  ham.addEventListener('click', () => {
    const isOpen = ham.classList.toggle('open');
    drawer.classList.toggle('open');
    if (nav) nav.classList.toggle('menu-open', isOpen);
    document.body.style.overflow = isOpen ? 'hidden' : '';
  });
  drawer.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {
    ham.classList.remove('open');
    drawer.classList.remove('open');
    if (nav) nav.classList.remove('menu-open');
    document.body.style.overflow = '';
  }));
}

// -- CART DRAWER --------------------------------
const cartOverlay = document.getElementById('cart-overlay');
const cartDrawer  = document.getElementById('cart-drawer');
const cartClose   = document.getElementById('cart-close');
const cartBtn     = document.getElementById('nav-cart-btn');

function openCart() {
  if (!cartDrawer) return;
  cartDrawer.classList.add('open');
  cartOverlay.classList.add('open');
  document.body.style.overflow = 'hidden';
  fetchCart();
}
function closeCart() {
  if (!cartDrawer) return;
  cartDrawer.classList.remove('open');
  cartOverlay.classList.remove('open');
  document.body.style.overflow = '';
}

if (cartBtn)     cartBtn.addEventListener('click', openCart);
const mobCartBtn = document.getElementById('mob-cart-btn');
if (mobCartBtn)  mobCartBtn.addEventListener('click', openCart);
if (cartClose)   cartClose.addEventListener('click', closeCart);
if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

// Fetch cart from Shopify AJAX API and render
async function fetchCart() {
  try {
    const res  = await fetch('/cart.js');
    const cart = await res.json();
    renderCart(cart);
  } catch (e) { console.warn('Cart fetch failed', e); }
}

function renderCart(cart) {
  const itemsEl    = document.getElementById('cart-items-list');
  const emptyEl    = document.getElementById('cart-empty');
  const footerEl   = document.getElementById('cart-footer');
  const subtotalEl = document.getElementById('cart-subtotal');
  const countEls   = document.querySelectorAll('.cart-item-count');
  const mobCountEl = document.getElementById('mobCartCountText');

  const count = cart.item_count || 0;
  countEls.forEach(el => { el.textContent = count > 0 ? `(${count})` : ''; });
  if (mobCountEl) mobCountEl.textContent = count > 0 ? `(${count})` : '';

  if (!itemsEl) return;

  if (count === 0) {
    // Clear any rendered items but keep the empty-state div in the DOM
    const existingItems = itemsEl.querySelectorAll('.cart-item');
    existingItems.forEach(el => el.remove());
    if (emptyEl)  emptyEl.style.display  = 'flex';
    if (footerEl) footerEl.style.display = 'none';
    return;
  }

  if (emptyEl)  emptyEl.style.display  = 'none';
  if (footerEl) footerEl.style.display = 'block';

  if (subtotalEl) {
    subtotalEl.textContent = formatMoney(cart.total_price);
  }

  itemsEl.innerHTML = cart.items.map(item => `
    <div class="cart-item" data-key="${item.key}">
      <div class="cart-item-img-placeholder">
        ${item.image ? `<img src="${item.image}" alt="${item.product_title}" class="cart-item-img" loading="lazy">` : ''}
      </div>
      <div>
        <div class="cart-item-name">${item.product_title}</div>
        <div class="cart-item-variant">${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : ''}</div>
        <div class="cart-item-qty">
          <button class="qty-btn" data-action="decrease" data-key="${item.key}" data-qty="${item.quantity}"></button>
          <span class="qty-num">${item.quantity}</span>
          <button class="qty-btn" data-action="increase" data-key="${item.key}" data-qty="${item.quantity}">+</button>
        </div>
        <button class="cart-item-remove" data-key="${item.key}">Remove</button>
      </div>
      <div class="cart-item-price">${formatMoney(item.line_price)}</div>
    </div>
  `).join('');

  // Qty buttons
  itemsEl.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', async () => {
      const key = btn.dataset.key;
      const qty = parseInt(btn.dataset.qty);
      const newQty = btn.dataset.action === 'increase' ? qty + 1 : Math.max(0, qty - 1);
      await updateCartItem(key, newQty);
    });
  });

  // Remove buttons
  itemsEl.querySelectorAll('.cart-item-remove').forEach(btn => {
    btn.addEventListener('click', async () => {
      await updateCartItem(btn.dataset.key, 0);
    });
  });
}

async function updateCartItem(key, quantity) {
  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    const cart = await res.json();
    renderCart(cart);
  } catch (e) { console.warn('Cart update failed', e); }
}

// Add to cart -- called from product form
async function addToCart(variantId, quantity = 1, properties = {}) {
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity, properties })
    });
    await res.json();
    openCart();
  } catch (e) { console.warn('Add to cart failed', e); }
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

// Expose for use in section scripts
window.StroudCart = { open: openCart, close: closeCart, add: addToCart, fetch: fetchCart };

// -- FILM STRIP DRAG ----------------------------
const strip = document.getElementById('filmStrip');
if (strip) {
  let isDown = false, startX, scrollLeft;
  strip.addEventListener('mousedown', e => {
    isDown = true; strip.style.cursor = 'grabbing';
    startX = e.pageX - strip.offsetLeft; scrollLeft = strip.scrollLeft;
  });
  ['mouseleave', 'mouseup'].forEach(ev =>
    strip.addEventListener(ev, () => { isDown = false; strip.style.cursor = 'grab'; })
  );
  strip.addEventListener('mousemove', e => {
    if (!isDown) return; e.preventDefault();
    strip.scrollLeft = scrollLeft - (e.pageX - strip.offsetLeft - startX) * 1.2;
  });
}

// -- PRODUCT PAGE -------------------------------
const productForm = document.getElementById('product-form');
if (productForm) {
  // Variant selection
  document.querySelectorAll('.opt-group').forEach(group => {
    group.querySelectorAll('.opt').forEach(btn => {
      btn.addEventListener('click', () => {
        group.querySelectorAll('.opt').forEach(b => b.classList.remove('sel'));
        btn.classList.add('sel');
        updateSelectedVariant();
      });
    });
  });

  function updateSelectedVariant() {
    // Find matching variant based on selected options
    const selectedOpts = Array.from(document.querySelectorAll('.opt.sel')).map(b => b.dataset.value);
    const variants = JSON.parse(document.getElementById('product-variants-json')?.textContent || '[]');
    const match = variants.find(v => {
      const vOpts = [v.option1, v.option2, v.option3].filter(Boolean);
      return selectedOpts.every(o => vOpts.includes(o));
    });
    if (match) {
      const variantInput = document.getElementById('selected-variant-id');
      if (variantInput) variantInput.value = match.id;
      const priceEl = document.getElementById('product-price-display');
      if (priceEl) priceEl.textContent = formatMoney(match.price);
    }
  }

  // Add to cart button
  const atcBtn = document.getElementById('atc-btn');
  if (atcBtn) {
    atcBtn.addEventListener('click', async () => {
      const variantId = document.getElementById('selected-variant-id')?.value;
      if (!variantId) return;
      atcBtn.textContent = 'Adding...';
      atcBtn.disabled = true;
      await window.StroudCart.add(parseInt(variantId), 1);
      atcBtn.textContent = 'Added ';
      atcBtn.style.background = 'var(--sage)';
      setTimeout(() => {
        atcBtn.textContent = 'Add to Cart';
        atcBtn.style.background = '';
        atcBtn.disabled = false;
      }, 2000);
    });
  }

  // Gallery thumbnails
  document.querySelectorAll('.thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      document.querySelectorAll('.thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      const mainImg = document.getElementById('gallery-main-img');
      if (mainImg && thumb.dataset.src) mainImg.src = thumb.dataset.src;
    });
  });
}

// -- COLLECTION FILTER --------------------------
const filterPills = document.querySelectorAll('.fpill');
if (filterPills.length) {
  const cards = document.querySelectorAll('.pc, .prod');
  const countEl = document.getElementById('projCount') || document.getElementById('cnt');

  filterPills.forEach(pill => {
    pill.addEventListener('click', () => {
      filterPills.forEach(p => p.classList.remove('on'));
      pill.classList.add('on');
      const f = pill.dataset.f || pill.dataset.c || 'all';
      let n = 0;
      cards.forEach(c => {
        const tags = (c.dataset.tags || c.dataset.c || '');
        const show = f === 'all' || tags.split(' ').includes(f);
        c.classList.toggle('hide', !show);
        if (show) n++;
      });
      if (countEl) countEl.textContent = n + (countEl.id === 'projCount' ? ` project${n !== 1 ? 's' : ''}` : ` piece${n !== 1 ? 's' : ''}`);
    });
  });
}

// -- PARALLAX FLOAT GRID ------------------------
(function() {
  function initParallax() {
    const items = document.querySelectorAll('.fi-parallax');
    if (!items.length) return;
    let ticking = false;
    function updateParallax() {
      items.forEach(item => {
        const speed = parseFloat(item.dataset.speed) || 0.12;
        const rect = item.getBoundingClientRect();
        const center = rect.top + rect.height / 2;
        const vCenter = window.innerHeight / 2;
        const offset = (center - vCenter) * speed;
        item.querySelector('.fi-img-inner').style.transform = `translateY(${offset}px)`;
      });
      ticking = false;
    }
    window.addEventListener('scroll', () => {
      if (!ticking) { requestAnimationFrame(updateParallax); ticking = true; }
    }, { passive: true });
    updateParallax();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initParallax);
  } else {
    initParallax();
  }
})();

// Hero slideshow
document.addEventListener('DOMContentLoaded', function() {
  var hero = document.getElementById('hero');
  if (!hero) return;
  var photos = hero.querySelectorAll('.hero-photo');
  if (photos.length < 2) return;
  var current = 0;
  var ms = parseInt(hero.getAttribute('data-interval'), 10) || 5000;
  var timer;
  function next() {
    photos[current].classList.remove('hero-photo--active');
    current = (current + 1) % photos.length;
    photos[current].classList.add('hero-photo--active');
  }
  function start() { timer = setInterval(next, ms); }
  function stop()  { clearInterval(timer); }
  hero.addEventListener('mouseenter', stop);
  hero.addEventListener('mouseleave', start);
  start();
});

// Footer clock — NW Arkansas (America/Chicago)
(function() {
  var el = document.getElementById('ftClock');
  if (!el) return;
  function tick() {
    var now = new Date();
    var str = now.toLocaleTimeString('en-US', {
      timeZone: 'America/Chicago',
      hour: 'numeric',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    });
    el.textContent = str;
  }
  tick();
  setInterval(tick, 1000);
}());

// Desktop product gallery: single image + 01/04 counter + prev/next
(function() {
  var main    = document.getElementById('galleryMain');
  var data    = document.getElementById('galleryData');
  var counter = document.getElementById('galleryCounter');
  var prev    = document.getElementById('galleryPrev');
  var next    = document.getElementById('galleryNext');
  var dots    = document.querySelectorAll('.gallery-indicators .g-dot');
  if (!main || !data) return;

  var total   = parseInt(data.dataset.total, 10);
  var current = 0;

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function goTo(idx) {
    current = (idx + total) % total;
    var src = data.getAttribute('data-src-' + current);
    var alt = data.getAttribute('data-alt-' + current);
    if (src) { main.src = src; main.alt = alt || ''; }
    if (counter) counter.innerHTML = pad(current + 1) + '&nbsp;/&nbsp;' + pad(total);
    dots.forEach(function(d, i) { d.classList.toggle('active', i === current); });
  }

  if (prev) prev.addEventListener('click', function() { goTo(current - 1); });
  if (next) next.addEventListener('click', function() { goTo(current + 1); });

  // Keyboard left/right when hovering gallery
  var gallery = main.closest('.gallery');
  if (gallery) {
    gallery.addEventListener('keydown', function(e) {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); goTo(current - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
    });
    gallery.setAttribute('tabindex', '0');
  }
}());

// Mobile product gallery: slide track + touch swipe + diamond indicators
(function() {
  var track = document.getElementById('galleryTrack');
  var dots = document.querySelectorAll('.gallery-indicators .g-dot');
  if (!track || !dots.length) return;

  var slides = track.querySelectorAll('.gallery-slide');
  var total = slides.length;
  var current = 0;

  function goTo(idx) {
    current = Math.max(0, Math.min(idx, total - 1));
    track.style.transform = 'translateX(-' + (current * 100) + '%)';
    dots.forEach(function(d, i) {
      d.classList.toggle('active', i === current);
    });
  }

  // Dot clicks
  dots.forEach(function(d) {
    d.addEventListener('click', function() { goTo(parseInt(d.dataset.index, 10)); });
  });

  // Touch swipe on the track wrap
  var wrap = track.parentElement;
  var startX = 0, startY = 0, dragging = false;
  wrap.addEventListener('touchstart', function(e) {
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    dragging = true;
  }, {passive: true});
  wrap.addEventListener('touchend', function(e) {
    if (!dragging) return;
    dragging = false;
    var dx = e.changedTouches[0].clientX - startX;
    var dy = e.changedTouches[0].clientY - startY;
    if (Math.abs(dx) < 30 || Math.abs(dy) > Math.abs(dx)) return;
    if (dx < 0) goTo(current + 1);
    else goTo(current - 1);
  }, {passive: true});
}());

// Mob ATC bar: slide up after scrolling past product title
(function() {
  var bar = document.getElementById('mobAtcBar');
  var title = document.querySelector('.prod-title');
  if (!bar || !title) return;
  function check() {
    var titleBottom = title.getBoundingClientRect().bottom;
    var threshold = window.innerHeight * (2/3);
    if (titleBottom < threshold) {
      bar.classList.add('visible');
    } else {
      bar.classList.remove('visible');
    }
  }
  window.addEventListener('scroll', check, {passive: true});
  check();
}());

// Project gallery: DOM reconstruction approach.
// Extracts all images from Shopify article.content regardless of wrapper tags
// (p, figure, div, bare) and rebuilds them as clean grid cells.
document.addEventListener('DOMContentLoaded', function() {
  var inner = document.getElementById('pjGallery');
  if (!inner) return;

  var allImgs = Array.from(inner.querySelectorAll('img'));
  if (!allImgs.length) return;

  // Rebuild the grid with clean .pj-cell wrappers -- one per image
  var cells = allImgs.map(function(img) {
    var cl = img.cloneNode(false);
    cl.removeAttribute('width');
    cl.removeAttribute('height');
    cl.style.cssText = 'width:100%;display:block;opacity:0;transform:translateY(24px);transition:opacity .95s ease,transform .95s ease;';
    var cell = document.createElement('div');
    cell.className = 'pj-cell';
    cell.appendChild(cl);
    return cell;
  });

  inner.innerHTML = '';
  cells.forEach(function(cell, i) {
    var delay = Math.min(i * 0.1, 0.48);
    var img = cell.querySelector('img');
    if (img) img.style.transitionDelay = delay + 's';
    inner.appendChild(cell);
  });

  // Landscape detection: if img is wider than tall, span the cell full width
  cells.forEach(function(cell) {
    var img = cell.querySelector('img');
    if (!img) return;
    function check() {
      if (img.naturalWidth && img.naturalHeight && img.naturalWidth > img.naturalHeight) {
        cell.classList.add('pj-landscape');
      }
    }
    if (img.complete && img.naturalWidth) { check(); }
    else { img.addEventListener('load', check); }
  });

  // Scroll reveal
  var freshImgs = Array.from(inner.querySelectorAll('img'));
  var fallback = setTimeout(function() {
    freshImgs.forEach(function(i) { i.style.opacity='1'; i.style.transform='none'; });
  }, 2000);

  if (!('IntersectionObserver' in window)) {
    clearTimeout(fallback);
    freshImgs.forEach(function(i) { i.style.opacity='1'; i.style.transform='none'; });
    return;
  }
  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        clearTimeout(fallback);
        e.target.style.opacity = '1';
        e.target.style.transform = 'none';
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0, rootMargin: '0px 0px 100px 0px' });
  freshImgs.forEach(function(img) { io.observe(img); });
});

// Project filmstrip drag -- mirrors homepage filmStrip drag
document.addEventListener('DOMContentLoaded', function() {
  var pjFilm = document.getElementById('pjFilmStrip');
  if (!pjFilm) return;
  var isDown = false, startX, scrollLeft;
  pjFilm.addEventListener('mousedown', function(e) {
    isDown = true; pjFilm.style.cursor = 'grabbing';
    startX = e.pageX - pjFilm.offsetLeft; scrollLeft = pjFilm.scrollLeft;
  });
  ['mouseleave', 'mouseup'].forEach(function(ev) {
    pjFilm.addEventListener(ev, function() { isDown = false; pjFilm.style.cursor = 'grab'; });
  });
  pjFilm.addEventListener('mousemove', function(e) {
    if (!isDown) return; e.preventDefault();
    pjFilm.scrollLeft = scrollLeft - (e.pageX - pjFilm.offsetLeft - startX) * 1.2;
  });
});

// Product info accordions — description + specs, mobile only
(function() {
  document.querySelectorAll('.prod-info-accordion-toggle').forEach(function(toggle) {
    var body = toggle.nextElementSibling;
    if (!body) return;
    toggle.addEventListener('click', function() {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      if (!open) {
        body.style.maxHeight = body.scrollHeight + 'px';
        body.classList.add('open');
      } else {
        body.style.maxHeight = '0px';
        body.classList.remove('open');
      }
    });
  });

  // Recalculate open accordion heights on resize (e.g. orientation change)
  window.addEventListener('resize', function() {
    document.querySelectorAll('.prod-info-accordion-body.open').forEach(function(body) {
      body.style.maxHeight = body.scrollHeight + 'px';
    });
  });
}());
